import { render, staticRenderFns } from "./BrandTabs.vue?vue&type=template&id=570dd9aa"
import script from "./BrandTabs.vue?vue&type=script&lang=js"
export * from "./BrandTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports